import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileFacadeService } from 'src/app/shared/services/profile/profile-facade.service';

@Injectable({
  providedIn: 'root'
})
export class TwoFactorAuthenticationGuard implements CanActivate {
  constructor(private profileService: ProfileFacadeService, private router: Router) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      return new Promise((resolve, reject) => {
        this.profileService.getPreInitials().subscribe(data => {
          const isSubUser = !data.merchant_detail.owner && !data.merchant_detail.admin;
          if(state.url.includes('settings') || state.url.includes('profile')) {
            resolve(true)
          } else {
            if(isSubUser) {
              if(!data?.google_two_step) {
                this.router.navigate(['/', 'dashboard', 'settings']);
              }
            } 
            if(!data?.is_password_updated) {
              this.router.navigate(['/', 'dashboard', 'profile']);
            }
          }
          resolve(true)
        }, error => {
          reject();
        })
      })
  }
}
